/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  CreateManualInvoiceRequest,
  EditInvoiceRequest,
  GetApiInvoiceExportParams,
  GetApiInvoiceList200,
  GetApiInvoiceListParams,
  GetApiInvoiceTotalParams,
  InvoiceApiResource,
  InvoiceTotalApiResource,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiInvoiceListResponse200 = {
  data: GetApiInvoiceList200
  status: 200
}

export type getApiInvoiceListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiInvoiceListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiInvoiceListResponseSuccess = (getApiInvoiceListResponse200) & {
  headers: Headers;
};
export type getApiInvoiceListResponseError = (getApiInvoiceListResponse401 | getApiInvoiceListResponse403) & {
  headers: Headers;
};

export type getApiInvoiceListResponse = (getApiInvoiceListResponseSuccess | getApiInvoiceListResponseError)

export const getGetApiInvoiceListUrl = (params?: GetApiInvoiceListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types[]","status[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices?${stringifiedParams}` : `/api/invoices`
}

export const getApiInvoiceList = async (params?: GetApiInvoiceListParams, options?: RequestInit): Promise<getApiInvoiceListResponse> => {
  
  return customFetch<getApiInvoiceListResponse>(getGetApiInvoiceListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiInvoiceCreateManualResponse201 = {
  data: InvoiceApiResource
  status: 201
}

export type postApiInvoiceCreateManualResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiInvoiceCreateManualResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiInvoiceCreateManualResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiInvoiceCreateManualResponseSuccess = (postApiInvoiceCreateManualResponse201) & {
  headers: Headers;
};
export type postApiInvoiceCreateManualResponseError = (postApiInvoiceCreateManualResponse400 | postApiInvoiceCreateManualResponse401 | postApiInvoiceCreateManualResponse404) & {
  headers: Headers;
};

export type postApiInvoiceCreateManualResponse = (postApiInvoiceCreateManualResponseSuccess | postApiInvoiceCreateManualResponseError)

export const getPostApiInvoiceCreateManualUrl = () => {


  

  return `/api/invoices`
}

export const postApiInvoiceCreateManual = async (createManualInvoiceRequest: CreateManualInvoiceRequest, options?: RequestInit): Promise<postApiInvoiceCreateManualResponse> => {
  
  return customFetch<postApiInvoiceCreateManualResponse>(getPostApiInvoiceCreateManualUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createManualInvoiceRequest,)
  }
);}


export type putApiInvoiceEditResponse200 = {
  data: InvoiceApiResource
  status: 200
}

export type putApiInvoiceEditResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiInvoiceEditResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiInvoiceEditResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiInvoiceEditResponseSuccess = (putApiInvoiceEditResponse200) & {
  headers: Headers;
};
export type putApiInvoiceEditResponseError = (putApiInvoiceEditResponse400 | putApiInvoiceEditResponse401 | putApiInvoiceEditResponse404) & {
  headers: Headers;
};

export type putApiInvoiceEditResponse = (putApiInvoiceEditResponseSuccess | putApiInvoiceEditResponseError)

export const getPutApiInvoiceEditUrl = (id: number,) => {


  

  return `/api/invoices/${id}`
}

export const putApiInvoiceEdit = async (id: number,
    editInvoiceRequest: EditInvoiceRequest, options?: RequestInit): Promise<putApiInvoiceEditResponse> => {
  
  return customFetch<putApiInvoiceEditResponse>(getPutApiInvoiceEditUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editInvoiceRequest,)
  }
);}


export type deleteApiInvoiceDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiInvoiceDeleteResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type deleteApiInvoiceDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiInvoiceDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiInvoiceDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiInvoiceDeleteResponseSuccess = (deleteApiInvoiceDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiInvoiceDeleteResponseError = (deleteApiInvoiceDeleteResponse400 | deleteApiInvoiceDeleteResponse401 | deleteApiInvoiceDeleteResponse403 | deleteApiInvoiceDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiInvoiceDeleteResponse = (deleteApiInvoiceDeleteResponseSuccess | deleteApiInvoiceDeleteResponseError)

export const getDeleteApiInvoiceDeleteUrl = (id: number,) => {


  

  return `/api/invoices/${id}`
}

export const deleteApiInvoiceDelete = async (id: number, options?: RequestInit): Promise<deleteApiInvoiceDeleteResponse> => {
  
  return customFetch<deleteApiInvoiceDeleteResponse>(getDeleteApiInvoiceDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type getApiInvoiceExportResponse200 = {
  data: Blob
  status: 200
}

export type getApiInvoiceExportResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiInvoiceExportResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiInvoiceExportResponseSuccess = (getApiInvoiceExportResponse200) & {
  headers: Headers;
};
export type getApiInvoiceExportResponseError = (getApiInvoiceExportResponse401 | getApiInvoiceExportResponse403) & {
  headers: Headers;
};

export type getApiInvoiceExportResponse = (getApiInvoiceExportResponseSuccess | getApiInvoiceExportResponseError)

export const getGetApiInvoiceExportUrl = (params?: GetApiInvoiceExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types[]","status[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices/export?${stringifiedParams}` : `/api/invoices/export`
}

export const getApiInvoiceExport = async (params?: GetApiInvoiceExportParams, options?: RequestInit): Promise<getApiInvoiceExportResponse> => {
  
  return customFetch<getApiInvoiceExportResponse>(getGetApiInvoiceExportUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiInvoiceTotalResponse200 = {
  data: InvoiceTotalApiResource
  status: 200
}

export type getApiInvoiceTotalResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiInvoiceTotalResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiInvoiceTotalResponseSuccess = (getApiInvoiceTotalResponse200) & {
  headers: Headers;
};
export type getApiInvoiceTotalResponseError = (getApiInvoiceTotalResponse401 | getApiInvoiceTotalResponse403) & {
  headers: Headers;
};

export type getApiInvoiceTotalResponse = (getApiInvoiceTotalResponseSuccess | getApiInvoiceTotalResponseError)

export const getGetApiInvoiceTotalUrl = (params?: GetApiInvoiceTotalParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["types[]","status[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices/total?${stringifiedParams}` : `/api/invoices/total`
}

export const getApiInvoiceTotal = async (params?: GetApiInvoiceTotalParams, options?: RequestInit): Promise<getApiInvoiceTotalResponse> => {
  
  return customFetch<getApiInvoiceTotalResponse>(getGetApiInvoiceTotalUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


